/*
 * TC 상품상세 리뷰 캐러셀 — Swiper (slidesPerView auto)
 * 각 .tc-pd-review 의 .tc-pd-review-list 를 초기화. nav는 같은 블록의 버튼.
 */
(function () {
  function init() {
    var wraps = document.querySelectorAll('.tc-pd-review');
    if (!wraps.length) return;
    if (typeof Swiper === 'undefined') { setTimeout(init, 50); return; }

    wraps.forEach(function (wrap) {
      var list = wrap.querySelector('.tc-pd-review-list');
      if (!list || list.dataset.swiperInit === '1') return;
      if (!list.querySelector('.swiper-slide')) return;
      list.dataset.swiperInit = '1';

      var count = list.querySelectorAll('.swiper-slide').length;
      new Swiper(list, {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: count > 1,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: wrap.querySelector('.tc-pd-review-next-btn'),
          prevEl: wrap.querySelector('.tc-pd-review-prev-btn'),
        },
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
